import { lazy_load } from './lazyload.js';
// $('.menu').css({ 'left': '-100000vw' });

// console.log(lazy_load.toString());

window.lazy_load = lazy_load;

jQuery(function($) {
    var timeout = 0.7;

    setTimeout(function() {
        $('body').removeClass('preload');
        console.log('Class removed!');
    }, timeout * 1000);

    $("body").on('click', '#ccc-icon', function(e){
        $('.checkbox-toggle--slider .checkbox-toggle-input').each(function(){
            if ($(this).is(':checked')) {
                $(this).parents('label').addClass('checked');
            } else {
                $(this).parents('label').removeClass('checked');
            }
        });
        e.preventDefault();
    });
    $("body").on('change', '.checkbox-toggle--slider .checkbox-toggle-input', function(e){
        var $this = $(this);
        window.setTimeout(function(){
            console.log(parseInt($this.parents('label').find('.checkbox-toggle-toggle').css('left')));
            if (parseInt($this.parents('label').find('.checkbox-toggle-toggle').css('left')) > 0) {
                $this.parents('label').addClass('checked');
            } else {
                $this.parents('label').removeClass('checked');
            }
        }, 410);
        e.preventDefault();
    });
    if ($('#projects').length) {
        var total_num_pages = $('#total-projects-pages').val();
        var url = $('#projects-url').val();
        var list_item_target = '.project-tile';
        var list_target = $('.large-contain');


        lazy_load(url, total_num_pages, null, list_item_target, list_target);
    }
});


$(() => {
    // href=#showreel click
    $('a[href="#showreel"]').on('click', () => {
        // console.log('showreel clicked');
    });

    $('.single-post_content').find('a').each(function() {
        $(this).attr('data-title', $(this).text());
    });
});

jQuery(function($) {
    let useClass = true;

    // If url contains #showreel, open modal
    if(window.location.hash === '#showreel') {
        let dialog = $('.modal')[0];

        $('video').prop('muted', 'true');

        playCFVideos();

        $(dialog).addClass('modal-open');
        $('body').addClass('modal-open');
        $('document').trigger('modal_opened', dialog);
        $(dialog).trigger('open');
    }

    $('.modal__header__close').on('click', function() {
        let dialog = $(this).closest('.modal');
        $(dialog).removeClass('modal-open');
        $('body').removeClass('modal-open');
        $('document').trigger('modal_closed', dialog);

        if(useClass) {
            $(dialog).removeClass('modal-open');
            $('body').removeClass('modal-open');
            $('document').trigger('modal_closed', dialog);
        } else {
            $(dialog)[0].close();
            $('body').removeClass('modal-open');
            $('document').trigger('modal_closed', dialog);
        }
    });

    $('[data-btn-action="openModal"]').on('click', function(e) {
        e.preventDefault();
        let dialog = $(this).attr('data-modal-target');
        $('video').prop('muted', false);

        if(useClass) {
            $(dialog).addClass('modal-open');
            $('body').addClass('modal-open');
            $('document').trigger('modal_opened', dialog);
            $(dialog).trigger('open');
        } else {
            $(dialog)[0].showModal();
            $('body').addClass('modal-open');
            $('document').trigger('modal_opened', dialog);
            $(dialog).trigger('open');
        }

        $(dialog).find('.modal__header__close').on('click', function(e) {
            e.preventDefault();
            let modal = $(this).closest('.modal');

            modal.removeClass('active');
            // modal.trigger('close');

            let video = modal.find('video')[0];
            video.pause();
            video.currentTime = 0;
        });
    });

    playCFVideos();

    $('document').on('modal_opened', function(e, dialog) {
        $(body).addClass('modal-open');
    });

    $('document').on('modal_closed', function(e, dialog) {
        $(body).removeClass('modal-open');
    });
});

function playCFVideos() {
    console.log('playCFVideos');

    // CF Player initialisation
    $('.cf-player').each(function(index, item) {
        let video_id = $(item).attr('data-video-id');

        if($(this).data('play-on') === 'open') {
            let target = $(this).attr('data-target');
            let modal = $(target);

            $(target).on('open', function (){
                let hls = new Hls();
                let video_hls_source = "https://videodelivery.net/"+video_id+"/manifest/video.m3u8";
                if (Hls.isSupported()) {
                    hls.loadSource(video_hls_source);
                    hls.attachMedia(item);
                } else if(item.canPlayType('application/vnd.apple.mpegURL')) {
                    console.error('HLS stream not supported')
                    item.src = video_hls_source;
                }
            });

            return;
        }

        let hls = new Hls();
        let video_hls_source = "https://videodelivery.net/"+video_id+"/manifest/video.m3u8";
        if (Hls.isSupported()) {
            hls.loadSource(video_hls_source);
            hls.attachMedia(item);
        } else if(item.canPlayType('application/vnd.apple.mpegURL')) {
            console.error('HLS stream not supported')
            item.src = video_hls_source;
        }
    });
}

export { playCFVideos };
